import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreateSubcategoryDTO, SortSubcategoryDTO, UpdateSubcategoryDTO } from "../models/subcategories/subcategories.request";
import { GetSubcategoryInfoDTO, SubcategorySelectDTO, SubcategorySelectWithCategoryDTO, SubcategorySettingsListItemDTO } from "../models/subcategories/subcategories.response";



export const subcategoryService = {

    async createSubcategory(localId: string, dto: CreateSubcategoryDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/locals/${localId}/subcategories`, dto);
        return data;
    },

    async getSubcategoriesByCategoryId(localId: string, categoryId: string): Promise<ApiResponse<SubcategorySettingsListItemDTO[]>> {
        const { data } = await api.get<ApiResponse<SubcategorySettingsListItemDTO[]>>(`/locals/${localId}/subcategories/settings`, {
            params: {
                categoryId: categoryId
            }
        });
        return data;
    },

    async getInfoById(localId: string, id: string): Promise<ApiResponse<GetSubcategoryInfoDTO>> {
        const { data } = await api.get<ApiResponse<GetSubcategoryInfoDTO>>(`/locals/${localId}/subcategories/${id}/settings`);
        return data;
    },

    async updateSubcategory(localId: string, id: string, dto: UpdateSubcategoryDTO): Promise<ApiResponse<string>> {
        const { data } = await api.put<ApiResponse<string>>(`/locals/${localId}/subcategories/${id}`, dto);
        return data;
    },

    async deleteSubcategory(localId: string, id: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/locals/${localId}/subcategories/${id}`);
        return data;
    },

    async sortSubcategories(localId: string, dto: SortSubcategoryDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/subcategories/sort`, dto);
        return data;
    },

    async getSubcategoriesSelectWithCategory(localId: string): Promise<ApiResponse<SubcategorySelectWithCategoryDTO[]>> {
        const { data } = await api.get<ApiResponse<SubcategorySelectWithCategoryDTO[]>>(`/locals/${localId}/subcategories/select`, {
            params: {
                withCategoryName: true
            }
        });
        return data;
    },

    async getSubcategoriesSelect(localId: string): Promise<ApiResponse<SubcategorySelectDTO[]>> {
        const { data } = await api.get<ApiResponse<SubcategorySelectDTO[]>>(`/locals/${localId}/subcategories/select`, {
            params: {
                withCategoryName: false
            }
        });
        return data;
    }

};